import { createSelector } from 'reselect';

const selectFeed = state => state.get('feed');

export const selectShowFeed = () =>
  createSelector(selectFeed, data => data.get('showFeed'));
